import { createSlice } from '@reduxjs/toolkit'

import { PostalAddress } from 'src/types/types'
import { CartState, UserType } from './types'

const initialState: CartState = {
  isCartDrawerOpen: false,
  userType: UserType.Sender,
  cartDetails: {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    additionalInfo: '',
    collectionDate: '',
    [UserType.Sender]: {
      postalAddress: {} as PostalAddress,
      streetAddress: '',
    },
    [UserType.Receiver]: {
      postalAddress: {} as PostalAddress,
      streetAddress: '',
    },
  },
}

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCartDetails: (state, action) => {
      state.cartDetails = action.payload
    },
    setUserType: (state, action) => {
      state.userType = action.payload
    },
    openCartDrawer: (state) => {
      state.isCartDrawerOpen = true
    },
    closeCartDrawer: (state) => {
      state.isCartDrawerOpen = false
    },
  },
})

export const { openCartDrawer, closeCartDrawer, setCartDetails, setUserType } = cartSlice.actions

export default cartSlice.reducer
